import React from 'react';
import Textbox from '@nib-components/textbox';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.EMAIL_ADDRESS,
  GU: DEFAULT_LABELS.EMAIL,
  IWHI: DEFAULT_LABELS.EMAIL,
  IMAN: DEFAULT_LABELS.EMAIL,
  ISHI: DEFAULT_LABELS.EMAIL,
  IAP: DEFAULT_LABELS.EMAIL
};
const Email = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 20,
    optional = false,
    required
  } = props;
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional,
    required: required
  }, React.createElement(Textbox, {
    type: "email",
    autoComplete: "email"
  }));
};
Email.defaultProps = defaultFieldPropTypes;
const EmailWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(Email, {
  ...props
}));
export default EmailWithFunnel;